
import { setToken, setNickName, setTrialUser } from '@/utils/auth'
import { encrypt,decrypt } from '@/utils/Crypto'
import Cookies from "js-cookie";
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'

export default {
components: {
CheckIcon,
XInput,
XButton,
Group,
ButtonTab,
ButtonTabItem,
Tab,
Cell,
TabItem,
Sticky,
},
name: "Login",
data() {
return {
passwordType: 'password',
userLogin: {
tempusername:"体验账户",
temppassword:"testdataUser",
username: "",
password: "",
phone: "",
checkingCode: "",
},
isLogindis: false,
isAgree: true,
list4: ["账号密码登录", "临时体验登录"],
title: "账号密码登录",
demo01: 0,
agreements: [{
title: "隐私政策",
url: "https://www.wordkillstu.com.cn/datainfo/用户服务条款.html"
},
{
title: "用户服务协议",
url: "https://www.wordkillstu.com.cn/datainfo/用户服务条款.html"
}
]
};
},
created() {
this.getCookie();
this.isLoginStatus()
},

methods: {

handleUserAgrement() {
let site = this.agreements[1]
this.$router.push({ path: '/yhfwxy_display'+`?title=${site.title}&url=https://www.wordkillstu.com.cn/datainfo/pc用户服务条款.html` });

},

handlePrivacy() {
let site = this.agreements[0]
this.$router.push({ path: '/yhfwxy_display'+`?title=${site.title}&url=https://www.wordkillstu.com.cn/datainfo/pc隐私条款.html` });

},

getCookie() {
let namedata = Cookies.get('username');
let password = Cookies.get('password');
this.isAgree = Cookies.get('isAgree')
if(namedata!=null&&password!=null){
this.userLogin.username= namedata
this.userLogin.password =password
}

if (this.$route.query.username != "" && this.$route.query.username != null) {

this.userLogin.username = this.$route.query.username
}
},
onClickIcon:function() {

var that = this
this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
}
,


register() {
this.$router.push({ path: '/sysRegister_display' });
},
notpassword(){
this.$router.push({ path: '/sysRetrieve_pass_display' });
},
isLoginStatus() {






if (this.userLogin.username != '' && this.userLogin.password != '' && this.title == '账号密码登录') {
this.isLogindis = false

} else if (this.userLogin.phone != '' && this.userLogin.checkingCode != '' && this.title == '手机快捷登录') {
this.isLogindis = false

} else if (this.title == '临时体验登录') {
this.isLogindis = false

} else {
this.isLogindis = true
}
},
switchTab(item) {
this.title = item
this.isLoginStatus()
},
login() {
let passWord =  decrypt(this.userLogin.password);
if(passWord==null||passWord==''){
this.userLogin.password = encrypt(this.userLogin.password,null,null );
}
if(this.title == '临时体验登录'){
this.$ajax.post(this.$api.templogin, { ...this.userLogin }).then(result => {
setToken(result)
setTrialUser(true)
this.$router.push({ path: '/wordIndex' });
this.$ajax.get(this.$api.getInfo).then(result => {

setNickName(result.user.nickName)
})
})
}else{
this.$ajax.post(this.$api.login, { ...this.userLogin }).then(result => {
if (this.isAgree) {
Cookies.set("username", this.userLogin.username, { expires: 6000 });
Cookies.set("password",this.userLogin.password, { expires: 6000 });
Cookies.set('isAgree', this.userLogin.isAgree, { expires: 6000 });



}else{
Cookies.remove("username");
Cookies.remove("password");
Cookies.remove('isAgree');
}
setToken(result)
setTrialUser(false)
this.$router.push({ path: '/wordIndex' });
this.$ajax.get(this.$api.getInfo).then(result => {

setNickName(result.user.nickName)
})
})
}

}
},
};



// WEBPACK FOOTER //
// ./src/views/sys/Login.vue